import React, { useState, useEffect } from "react";
import DatePicker from "../generic/DatePicker";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "components/ui/label";
import TimePicker from "components/crewManagement/TimePicker";

const ProjectBriefForm = ({ passRef, handleSubmit, initialData }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [selectedDate, setSelectedDate] = useState(null);
  const [dueTime, setDueTime] = useState("");
  const [callSchedule, setcallSchedule] = useState("");
  const [keyDeliverables, setKeyDeliverables] = useState("");
  const [specialInstructions, setSpecialInstructions] = useState("")  ;
  const [contactName, setContactName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
  if (initialData) {
    if (initialData.title) setTitle(initialData.title);
    if (initialData.description) setDescription(initialData.description);

    if (initialData.event_date) {
      setSelectedDate(initialData.event_date);
    }
  }
}, [initialData]);

  const onSubmit = (e) => {
    e.preventDefault();

    const formData = {
      brief_title: title,
      project_overview: description,
      event_time: dueTime,
      event_date: selectedDate,
      call_time_schedule: callSchedule,
      key_deliverables: keyDeliverables,
      special_instructions: specialInstructions,
      main_contact_name: contactName,
      contact_phone: phone,
      contact_email: email,
    };

    handleSubmit(formData);
  };

  return (
    <form
      ref={passRef}
      onSubmit={onSubmit}
      className="flex flex-col gap-6"
    >
      {/* Hidden inputs for state-managed fields */}
      {/* <input type="hidden" name="event_type" value={selectedEvent} /> */}
      {/* <input type="hidden" name="event_date" value={selectedDate ? selectedDate.toISOString() : ''} /> */}
      {/* <input type="hidden" name="event_date" value={selectedDate ? selectedDate : ''} /> */}

      <div className="border border-border bg-card rounded-2xl items-start p-6">
        <div className="flex flex-col gap-1.5 mb-6">
          <div className="-primary text-2xl font-semibold leading-6">Project Brief</div>
        </div>
        <div className=" flex-1 flex flex-col items-start gap-4">
          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label  text-sm font-bold leading-4" htmlFor="brief_title">Project Name</Label>
             <Input
              type="text"
              id="brief_title"
              placeholder="e.g., Annual Tech Conference"
              required
              onChange={(e) => setTitle(e.target.value)}
              value={title} // Bound to state
            />
          </div>
          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label  text-sm font-bold leading-4" htmlFor="project_overview">Description</Label>
            <Textarea
              name="project_overview"
              id="project_overview"
              placeholder="Describe your livestream event, objectives, and any special requirements..."
              onChange={(e) => setDescription(e.target.value)}
              value={description}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4 w-full">
            <div className="w-full flex flex-col gap-2">
              <Label className="label  text-sm font-bold leading-4" htmlFor="event_type">Event Time</Label>
               <TimePicker
        setTime={setDueTime}
        value={dueTime} // This now works because of the change in TimePicker.js
        className="border border-border"
      />
            </div>

            <div className="w-full flex flex-col gap-2">
              <Label className="label  text-sm font-bold leading-4" htmlFor="event_date">Event Date</Label>
                <DatePicker
        id="event_date"
        value={selectedDate} // Changed 'selected' to 'value'
        onChange={(d) => setSelectedDate(d)}
      />
            </div>
          </div>
          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label  text-sm font-bold leading-4" htmlFor="schedule">Call Time & Schedule</Label>
            <Input
              type="text"
              name="schedule"
              id="schedule"
              placeholder="Detail the day-of schedule, call times, and key milestones..."
              onChange={(e) => setcallSchedule(e.target.value)}
              value={callSchedule}
            />
          </div>

          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label  text-sm font-bold leading-4" htmlFor="key_deliverables">Key Deliverables</Label>
            <Textarea
              name="key_deliverables"
              id="key_deliverables"
              placeholder="List expected outputs, stream platforms, recording requirements..."
              onChange={(e) => setKeyDeliverables(e.target.value)}
              value={keyDeliverables}
            />
          </div>

          <div className="flex flex-col items-start gap-2 w-full">
            <Label className="label  text-sm font-bold leading-4" htmlFor="special_instructions">Special Instructions</Label>
            <Textarea
              name="special_instructions"
              id="special_instructions"
              placeholder="Any special requirements, restrictions, or important notes..."
              onChange={(e) => setSpecialInstructions(e.target.value)}
              value={specialInstructions}
            />
          </div>
        </div>
      </div>

      <div className="border border-border bg-card rounded-2xl items-start p-6">
        <div className="-primary text-2xl font-semibold leading-6 mb-4">Contact Information</div>
        <div className="flex flex-col md:flex-row gap-4 w-full mb-4">
          <div className="w-full flex flex-col gap-2">
            <Label className="label  text-sm font-bold leading-4" htmlFor="contact_name">Main Contact Name</Label>
            <Input
              type="text"
              name="contact_name"
              id="contact_name"
              placeholder="Enter Name"
              onChange={(e) => setContactName(e.target.value)}
              value={contactName}
            />
          </div>
          <div className="w-full flex flex-col gap-2">
            <Label className="label  text-sm font-bold leading-4" htmlFor="contact_number">Contact Phone</Label>
            <div className="relative w-full">
              <div className="absolute inset-y-0 left-3 flex items-center gap-2 pointer-events-none">
                {/* <img
                  src="/images/misc/USA.png"
                  alt="US flag"
                  className="w-5 h-5 rounded-full object-cover"
                /> */}
                {/* <span className="text-sm text-grey-primary">+1</span> */}
              </div>
              <Input
                type="tel"
                name="contact_number"
                id="contact_number"
                placeholder="Enter phone number"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
              />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col gap-2">
          <Label className="label text-sm font-bold leading-4" htmlFor="contact_email">Contact Email</Label>
          <Input
            type="email"
            name="contact_email"
            id="contact_email"
            placeholder="contact@company.com"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </div>
      </div>
    </form >
  )
}


export default ProjectBriefForm
